<template>
  <div class="home">
    <el-carousel :interval="5000" arrow="always" class="banner" height="416px">
      <el-carousel-item v-for="(item,index) in advertisements" :key="index">
        <el-image :src="item.previewUrl" fit="fill" class="width100 height100" @click="handleAdvertisementClick(item)">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </el-carousel-item>
    </el-carousel>
    <div class="toutiao flex" style="margin-top: 20px">
      <div class="toutiao-title">今&nbsp;&nbsp;日<br/>头&nbsp;&nbsp;条</div>
      <div class="flex-1">
        <el-carousel class="toutiao-content" direction="vertical" :interval="5000" arrow="never" indicator-position="none">
          <el-carousel-item v-for="(item,index) in topNews" :key="index">
            <!--el-link type="info" class="toutiao-link">{{ item.newsTitle }}</el-link-->
            <table style="height: 80px;width: 100%">
              <tr>
                <td>
                <p class="toutiao-link">{{ item.newsTitle }}</p>
                </td>
              </tr>
            </table>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--section-area title="最新发布" style="margin-top: 20px"></section-area-->
    <div style="margin: 50px 0px;"><el-divider><span style="font-size:30px;font-weight: bold">最新发布</span></el-divider></div>
    <div class="latest">
      <SeamlessScroll :data="latestNews" :class-option="seamlessScrollOption" class="seamless-warp">
        <ul class="item">
          <li v-for="(item,index) in latestNews" :key="index">
            <card-large :trade="item"></card-large>
          </li>
        </ul>
      </SeamlessScroll>
      <!--SeamlessScroll :data="latestNews" :class-option="seamlessScrollOption" style="overflow: hidden;width: 1200px">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in latestNews" :key="index">
            <card-large :trade="item"></card-large>
          </el-col>
        </el-row>
      </SeamlessScroll-->
      <!--el-row :gutter="20">
        <SeamlessScroll :limitMoveNum="1" :direction="3">
        <el-col :span="6" v-for="(item,index) in latestNews" :key="index">
            <card-large :trade="item"></card-large>
        </el-col>
        </SeamlessScroll>
      </el-row-->
    </div>
    <div style="margin: 50px 0px;"><el-divider><span style="font-size:30px;font-weight: bold">诚意发布</span></el-divider></div>
    <div class="sincerity flex" style="margin-top: 0px">
      <div class="demand flex-1">
        <section-area title="采购需求" button-name="更多>>" @buttonClick="moreDemand"></section-area>
        <el-row :gutter="20">
          <el-col class="demand-col" :span="12" v-for="(demand,index) in demandNews" :key="index">
            <card-trade :trade="demand"></card-trade>
          </el-col>
        </el-row>
      </div>
      <div class="supply flex-1">
        <section-area title="供应资源" button-name="更多>>" @buttonClick="moreSupply"></section-area>
        <el-row :gutter="20">
          <el-col class="supply-col" :span="12" v-for="(supply,index) in supplyNews" :key="index">
            <card-trade :trade="supply"></card-trade>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--section-area title="热门推荐" style="margin-top: 20px"></section-area-->
    <div style="margin: 50px 0px;"><el-divider><span style="font-size:30px;font-weight: bold;">热门推荐</span></el-divider></div>
    <div class="recommend">
      <el-row :gutter="20">
        <el-col class="recommend-col" :span="12" v-for="(recommend,index) in recommendNews" :key="index">
          <card-recommend :trade="recommend"></card-recommend>
        </el-col>
      </el-row>
    </div>
    <div class="load-more" v-infinite-scroll="loadMore" infinite-scroll-immediate="false" :infinite-scroll-disabled="scroll.busy || scroll.empty" infinite-scroll-distance="30">
      <span v-if="scroll.empty == false">加载更多...</span>
    </div>
    <el-dialog :title="clickAdvertisement.title" :visible.sync="adDialogVisible" width="80%" center>
      <div v-html="clickAdvertisement.content"></div>
    </el-dialog>
  </div>
</template>

<script>

  import SectionArea from '@/components/section-area'
  import CardLarge from '@/components/card-large'
  import CardTrade from '@/components/card-trade'
  import CardRecommend from '@/components/card-recommend'
  import { mapGetters, mapMutations } from 'vuex'
  import { Menu, IMAGE_BASE_URL, Trade } from '../../util/constants'
  import {apiLatestPublishedTradeList, apiSincereTradeList, apiRecommendTradeList} from '../../api/trade'
  import {apiHomeAdvertisement, apiHomeLatestTop} from '../../api/home'
  import {formatDate} from '../../util/common'
  import SeamlessScroll from 'vue-seamless-scroll'

  export default {
    name: 'index',
    components: {
      SectionArea, CardLarge, CardTrade, CardRecommend, SeamlessScroll
    },
    data() {
      return {
        scroll: {
          busy: false,
          empty: false
        },
        seamlessScrollOption: {
          direction: 2,
          limitMoveNum: 4
        },
        // busyScroll: false,
        // emptyScroll: false,
        adDialogVisible: false,
        clickAdvertisement: {},
        advertisements: [],
        topNews: [],
        latestNews: [],
        demandNews: [],
        supplyNews: [],
        recommendNews: [],
        pageIndex: 1
      }
    },
    created() {
      this.setActiveMenuIndex(Menu.Home)
      this.getHomeAdvertisement()
      this.getHomeLatestTopNews()
      this.getLatestPublishedTradeList()
      this.getSincereTradeList()
      this.getRecommendTradeList()
    },
    methods: {
      ...mapMutations({
        setActiveMenuIndex: 'SET_ACTIVE_MENU_INDEX'
      }),
      moreDemand() {
        this.$router.push({
          name: 'demand'
        })
      },
      moreSupply() {
        this.$router.push({
          name: 'demand'
        })
      },
      getLatestPublishedTradeList() {
        apiLatestPublishedTradeList(10).then(({module}) => {
          this.latestNews = module.list
        })
      },
      getHomeAdvertisement() {
        apiHomeAdvertisement(10).then(({module}) => {
            module.forEach(m => (m.previewUrl = IMAGE_BASE_URL + m.previewUrl))
            this.advertisements = module
        })
      },
      getHomeLatestTopNews() {
        apiHomeLatestTop(10).then(({module}) => {
          this.topNews = module
        })
      },
      getSincereTradeList() {
        apiSincereTradeList(6, Trade.Demand).then(({module}) => {
          this.demandNews = module.list
        })
        apiSincereTradeList(6, Trade.Supply).then(({module}) => {
          this.supplyNews = module.list
        })
      },
      getRecommendTradeList() {
        this.scroll.busy = true
        let _this = this
        apiRecommendTradeList(this.pageIndex, 12)
        .then(({module}) => {
          _this.scroll.busy = false
          if (module.list == null || module.list.length === 0) {
            _this.scroll.empty = true
          } else {
            if (module.list.length < 12) {
              this.scroll.empty = true
            } else {
              this.scroll.empty = false
            }
            _this.recommendNews = _this.recommendNews.concat(module.list)
          }
        })
        .catch(() => {
          _this.scroll.busy = false
        })
      },
      handleAdvertisementClick(image) {
        if (image.linkable === 1) {
          window.open(image.linkUrl, '_blank')
        } else {
          this.clickAdvertisement = image
          this.adDialogVisible = true
        }
      },
      loadMore() {
        this.pageIndex++
        this.getRecommendTradeList()
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../style/variables.scss';
  .banner .el-carousel__item {
    background-color: #99a9bf;
  }

  .content-divider {
    margin: 20px 0;
    & >>> .el-divider__text {
      font-size: 18px !important;
      font-weight: bold;
    }
  }

  .toutiao {
    align-items: center;
  }

  .toutiao-title {
    text-align: center;
    width: 80px;
    height: 80px;
    line-height: 40px;
    font-size: 30px;
    font-weight: bold;
    color:$theme-yellow;
    margin: 5px 10px;
    padding-right: 10px;
    border-right: 1px solid $theme-gray;
  }

  .toutiao-content {
    height: 80px;
    font-size: 18px;
    /*line-height: 80px;
    overflow: hidden;
    white-space:nowrap;*/
    .toutiao-link {
      margin: 0;
      font-size: 22px;
      font-weight: bold;

      overflow: hidden;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      box-orient: vertical;
      display: -webkit-box;
    }
  }

  .sincerity {
    margin-top: 10px;
  }

  .demand {
    width: 1%;
    padding-right: 10px;
    border-right: 1px solid #d2d2d2;
    .demand-col:nth-child(n+3) {
      margin-top: 10px;
    }
  }

  .supply {
    width: 1%;
    margin-left: 10px;
    .supply-col:nth-child(n+3) {
      margin-top: 10px;
    }
  }
  .recommend {
    .recommend-col:nth-child(n+3) {
      margin-top: 10px;
    }
  }

  .seamless-warp {
    overflow: hidden;
    width: 1200px;
    ul.item {
      /*width: 2210px;*/
      display: flex;
      li {
        margin-right: 10px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/view/home/index.vue